import { LoadingIcon } from '@/components/icons/svg-icons';
import React from 'react'

interface MatchOddsLoadingWrapperProps {
	isLoading: boolean;
    children: React.ReactNode;
}

export const MatchOddsLoadingWrapper = ({ isLoading, children }: MatchOddsLoadingWrapperProps) => {
	return isLoading ? (
		<div className="loading-circle">
			<LoadingIcon />
		</div>
	) : (
		<>
			{ children }
		</>
	);
}